import { POINTS_FOR_WIN } from "../constants";

const calculateTeamStats = (matches, teams, pointsPerWin = POINTS_FOR_WIN) => {
  if (!matches || !teams || !pointsPerWin) {
    return;
  }

  const stats = {};

  for (const teamId of Object.keys(teams)) {
    stats[teamId] = {
      wins: 0,
      draws: 0,
      losses: 0,
      goalsFor: 0,
      goalsAgainst: 0,
      goalDifference: 0,
      points: 0,
    };
  }

  for (const match of Object.values(matches)) {
    const { team1Id, team1Score, team2Id, team2Score } = match;

    if (
      (!team1Score && team1Score !== 0) ||
      (!team2Score && team2Score !== 0)
    ) {
      continue;
    }

    if (team1Score > team2Score) {
      stats[team1Id].wins++;
      stats[team2Id].losses++;
    } else if (team1Score < team2Score) {
      stats[team2Id].wins++;
      stats[team1Id].losses++;
    } else {
      stats[team1Id].draws++;
      stats[team2Id].draws++;
    }

    stats[team1Id].goalsFor += team1Score;
    stats[team2Id].goalsFor += team2Score;

    stats[team1Id].goalsAgainst += team2Score;
    stats[team2Id].goalsAgainst += team1Score;
  }

  for (const teamId of Object.keys(teams)) {
    stats[teamId].goalDifference =
      stats[teamId].goalsFor - stats[teamId].goalsAgainst;

    stats[teamId].points =
      stats[teamId].wins * pointsPerWin + stats[teamId].draws;
  }

  return stats;
};

export default calculateTeamStats;
